/* Elegant² by eStark – Interaktionen (Hotspots, Lupe, Galerie, FAQ-Tabs, Concierge) */
(function () {
  'use strict';
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* Hotspots auf dem Look-Foto: x/y sind Anteile (0–1) im Originalbild, wir rechnen object-fit: cover nach */
  function placeLook(stage) {
    var img = stage.querySelector('img');
    if (!img) return;
    var W = img.clientWidth, H = img.clientHeight;
    var iw = img.naturalWidth || +img.getAttribute('width') || 1, ih = img.naturalHeight || +img.getAttribute('height') || 1;
    var sc = Math.max(W / iw, H / ih), dw = iw * sc, dh = ih * sc, ox = (W - dw) / 2, oy = (H - dh) / 2;
    qsa('.e2-hs', stage).forEach(function (a) {
      var x = parseFloat(a.getAttribute('data-x')) / 100, y = parseFloat(a.getAttribute('data-y')) / 100;
      a.style.left = (ox + x * dw) + 'px';
      a.style.top = (oy + y * dh) + 'px';
    });
  }
  function initLooks(root) {
    qsa('[data-e2-look]', root).forEach(function (stage) {
      var img = stage.querySelector('img');
      if (!img) return;
      if (img.complete) placeLook(stage); else img.addEventListener('load', function () { placeLook(stage); });
      if (!stage._e2ro && 'ResizeObserver' in window) { stage._e2ro = new ResizeObserver(function () { placeLook(stage); }); stage._e2ro.observe(stage); }
    });
  }

  /* Lupe auf der Produktseite */
  function initLoupe(root) {
    qsa('[data-e2-loupe]', root).forEach(function (plate) {
      if (plate._e2l) return; plate._e2l = true;
      var Z = 2.6, R = 95, lens = null;
      function hide() { if (lens) { lens.remove(); lens = null; } }
      plate.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var src = plate.getAttribute('data-zoom'); if (!src) return;
        var r = plate.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        if (x < 0 || y < 0 || x > r.width || y > r.height) { hide(); return; }
        if (!lens) { lens = document.createElement('div'); lens.className = 'e2-lens'; plate.appendChild(lens); }
        var img = plate.querySelector('img'), iw = img.naturalWidth || 1, ih = img.naturalHeight || 1;
        var sc = Math.max(r.width / iw, r.height / ih) * Z, dw = iw * sc, dh = ih * sc;
        var ox = (r.width * Z - dw) / 2, oy = (r.height * Z - dh) / 2;
        lens.style.backgroundImage = 'url("' + src + '")';
        lens.style.backgroundSize = dw + 'px ' + dh + 'px';
        lens.style.backgroundPosition = (ox - x * Z + R) + 'px ' + (oy - y * Z + R) + 'px';
        lens.style.left = (x - R) + 'px'; lens.style.top = (y - R) + 'px';
      });
      plate.addEventListener('pointerleave', hide);
      plate._e2hide = hide;
    });
  }

  /* Galerie-Thumbnails */
  function initThumbs(root) {
    qsa('[data-e2-gallery]', root).forEach(function (g) {
      var plate = g.querySelector('[data-e2-loupe]'), main = plate && plate.querySelector('img');
      qsa('[data-e2-thumb]', g).forEach(function (t) {
        t.addEventListener('click', function () {
          if (!main) return;
          main.src = t.getAttribute('data-src');
          main.removeAttribute('srcset');
          main.alt = t.getAttribute('data-alt') || main.alt;
          plate.setAttribute('data-zoom', t.getAttribute('data-zoom'));
          if (plate._e2hide) plate._e2hide();
          qsa('[data-e2-thumb]', g).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
        });
      });
    });
  }

  /* FAQ-Tabs */
  function initTabs(root) {
    qsa('[data-e2-tabs]', root).forEach(function (wrap) {
      var tabs = qsa('[data-e2-tab]', wrap), groups = qsa('[data-e2-group]', wrap);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var k = t.getAttribute('data-e2-tab');
          tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
          groups.forEach(function (gp) { gp.hidden = gp.getAttribute('data-e2-group') !== k; });
        });
      });
    });
  }

  /* Auswahlfelder, die navigieren (Sortierung, Marke) */
  function initNavSelects(root) {
    qsa('select[data-e2-nav]', root).forEach(function (s) {
      s.addEventListener('change', function () { if (s.value) window.location.href = s.value; });
    });
  }

  /* Concierge */
  function initConcierge() {
    var b = document.querySelector('.e2-concierge'), p = document.getElementById('e2-cpanel');
    if (!b || !p || b._e2) return; b._e2 = true;
    function set(open) { p.hidden = !open; b.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    b.addEventListener('click', function (e) { e.stopPropagation(); set(p.hidden); });
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-e2-concierge]');
      if (o) { e.preventDefault(); set(true); return; }
      if (!p.hidden && !p.contains(e.target) && e.target !== b) set(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  function init(root) { initLooks(root); initLoupe(root); initThumbs(root); initTabs(root); initNavSelects(root); initConcierge(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
